export default {
  methods: {
    formatHomeSafeText(text) {
      if (!text) return "";

      // Match "HomeSafe" with optional spaces and the ® symbol, case-insensitive
      const regex = /home\s*safe\s*(®|&reg;)?/gi;

      return text.replace(regex, function(match) {
        let replacement = "Home<em>Safe</em><sup>&reg;</sup>";

        // Space added if there's more text after the match
        return replacement + (match[match.length - 1] === ' ' ? ' ' : '');
      });
    }
  }
};